module.exports = __webpack_public_path__ + "img/video_btn.d571560c.png";